export const UPLOAD_PAYROLL_REQUEST = "UPLOAD_PAYROLL_REQUEST";
export const UPLOAD_PAYROLL_REQUEST_SUCCESS = "UPLOAD_PAYROLL_REQUEST_SUCCESS";

export const UPLOAD_PAYROLL_REQUEST_ERROR = "UPLOAD_PAYROLL_REQUEST_ERROR";
export const CLEAR_ERROR = "CLEAR_PAYROLL_ERROR";

export const TOGGLE_PROCESSING = "TOGGLE_PAYROLL_PROCESSING";